import { ChangeEvent, memo, useEffect, useState, VFC } from "react";
import {
  Badge,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";

import { Tenant } from "../../../types/api/tenant";
import { PrimaryButton } from "../../atoms/button/PrimaryButton";
import { useTenant } from "../../../hooks/useTenant";
import { SecurityLevelType,PermissionInfo } from "../../../types/api/security";

type Props = {
  tenant: Tenant | undefined;
  isOpen: boolean;
  isAdmin?: boolean;
  onClose: () => void;
};

export const TenantDetailModal: VFC<Props> = memo((props) => {
  const { isOpen, onClose, isAdmin = false, tenant } = props;
  const isAddMode: boolean = tenant ? false : true;
  const { tenantEdit, tenantDelete, loading } = useTenant();

  const [tenantId, setTenantId] = useState("");
  const [accountName, setAccountName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [identityPoolId, setIdentityPoolId] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [tier, setTier] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    onModalReset();
  }, [tenant]);

  const onChangeTenantId = (e: ChangeEvent<HTMLInputElement>) =>
    setTenantId(e.target.value);
  const onChangeAccountName = (e: ChangeEvent<HTMLInputElement>) =>
    setAccountName(e.target.value);
  const onChangeCompanyName = (e: ChangeEvent<HTMLInputElement>) =>
    setCompanyName(e.target.value);
  const onChangeEmail = (e: ChangeEvent<HTMLInputElement>) =>
    setEmail(e.target.value);
  const onChangeIdentityPoolId = (e: ChangeEvent<HTMLInputElement>) =>
    setIdentityPoolId(e.target.value);
  const onChangeOwnerName = (e: ChangeEvent<HTMLInputElement>) =>
    setOwnerName(e.target.value);
  const onChangeTier = (e: ChangeEvent<HTMLInputElement>) =>
    setTier(e.target.value);
  const onChangeStatus = (e: ChangeEvent<HTMLInputElement>) =>
    setStatus(e.target.value);

  const onClickUpdate = () => {
    var upTenant: Tenant = {
      tenant_id: tenantId,
      companyName: companyName,
      accountName: accountName,
      email: email,
      IdentityPoolId: identityPoolId,
      ownerName: ownerName,
      tier: tier,
      status: status,
    };

    tenantEdit(upTenant);
  };

  const onClickDelete = () => {
    tenantDelete(tenantId);
  };

  const onModalReset = () => {
    if(tenant){
      setTenantId(tenant?.tenant_id ?? "");
      setAccountName(tenant?.accountName ?? "");
      setCompanyName(tenant?.companyName ?? "");
      setEmail(tenant?.email ?? "");
      setIdentityPoolId(tenant?.IdentityPoolId ?? "");
      setOwnerName(tenant?.ownerName ?? "");
      setTier(tenant?.tier ?? "");
      setStatus(tenant?.status ?? "");  
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={()=>{onModalReset();onClose()}}
      motionPreset="slideInBottom"
      autoFocus={false}
    >
      <ModalOverlay />
      <ModalContent pb={2}>
        <ModalHeader>テナント詳細</ModalHeader>
        <ModalCloseButton />
        <ModalBody mx={{base:0,md:6}}>
          <Stack spacing={4}>
            <FormControl>
              <FormLabel>Tenant 
              { isAddMode ? (<Badge colorScheme="red" ml={2}>必須</Badge>) : (<Badge colorScheme="gray" ml={2}>変更不可</Badge>)}
              </FormLabel>
              <Input
                readOnly={!isAddMode}
                value={tenantId}
                onChange={onChangeTenantId}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Account Name</FormLabel>
              <Input value={accountName} onChange={onChangeAccountName} />
            </FormControl>
            <FormControl>
              <FormLabel>company Name</FormLabel>
              <Input value={companyName} onChange={onChangeCompanyName} />
            </FormControl>
            <FormControl>
              <FormLabel>email</FormLabel>
              <Input type="email" value={email} onChange={onChangeEmail} />
            </FormControl>
            <FormControl>
              <FormLabel>Identity Pool Id</FormLabel>
              <Input value={identityPoolId} onChange={onChangeIdentityPoolId} />
            </FormControl>
            <FormControl>
              <FormLabel>owner Name</FormLabel>
              <Input value={ownerName} onChange={onChangeOwnerName} />
            </FormControl>
            <FormControl>
              <FormLabel>Tier</FormLabel>
              <Input value={tier} onChange={onChangeTier} />
            </FormControl>
            <FormControl>
              <FormLabel>Status</FormLabel>
              <Input value={status} onChange={onChangeStatus} />
            </FormControl>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <PrimaryButton onClick={onClickUpdate}>更新</PrimaryButton>
          <PrimaryButton onClick={onClickDelete}>削除</PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
